module.exports = {
    'orders.users.orders.index': 'users/$1/orders',
};
